import * as React from "react";
type Props = {
  className?: string,
};
function SvgNone({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-None"
      className={className}
    >
      <path
        d="M3 20C3 16.6377 3.99702 13.3511 5.86501 10.5555C7.733 7.75983 10.388 5.58072 13.4944 4.29403C16.6007 3.00734 20.0188 2.67072 23.3165 3.32667C26.6142 3.98262 29.6433 5.60171 32.0208 7.97921C34.3983 10.3567 36.0174 13.3859 36.6733 16.6836C37.3293 19.9813 36.9927 23.3994 35.706 26.5058C34.4193 29.6121 32.2403 32.2671 29.4447 34.1351C26.649 36.0031 23.3623 37 20 37C15.4913 37 11.1672 35.2092 7.97911 32.021C4.79098 28.8329 3 24.5087 3 20Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M7.88562 32.2581L33.2951 9.6601"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgNone;
